import { service } from '@ember/service';

import type { RecordData, Service, ValidationErrors } from 'webapp-types';
import { ModelName } from 'webapp/enums/enums';

import BufferedModel from 'webapp/models-custom/buffer/buffered-model';
import type TagRecord from 'webapp/models/tag';

export default class Tag extends BufferedModel<TagRecord, RecordData.Tag.Serialized> {
	@service('model-manager/tags') declare mmTagsService: Service.ModelManager.Tags;

	// ------- props from / to ED record ------

	get id() {
		return this.model.id;
	}

	get name(): string {
		return this.getBuffered('name');
	}

	set name(value: string) {
		this.setBuffered('name', value);
	}

	get color(): string {
		return this.getBuffered('color');
	}

	set color(value: string) {
		this.setBuffered('color', value);
	}

	get createdBy(): number | null {
		return this.model.createdBy;
	}

	// ------- other props ------

	override validate() {
		// only validating the name
		const isEmptyName = !this.name,
			isDefaultName = this.name === Tag.DEFAULT_NAME,
			isDuplicateName =
				this.mmTagsService.savedRecords.filter((tag) => {
					return tag.name === this.name && tag.id !== this.id;
				}).length > 0;

		this.cleanupErrorsIfOnlyGeneral();

		const errors: ValidationErrors<'name'> = {};
		if (isEmptyName) {
			errors.name = [{ message: 'Name is mandatory!' }];
		} else if (isDuplicateName) {
			errors.name = [{ message: 'Tag with such name already exists!' }];
		} else if (isDefaultName) {
			errors.name = [{ message: 'Please change the name of the tag!' }];
		}

		this.setValidationErrors(errors);

		return Object.keys(errors).length === 0;
	}

	static DEFAULT_NAME = 'New tag';

	static override modelName = ModelName.TAG; // store record type
}
